// extracted by css-extract-rspack-plugin
export default {"input":"sFH1J"};